import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React, { useContext, useEffect, useState } from "react";
import { PulseLoader } from "react-spinners";
import CampaignContext from "../../../contexts/CampaignContext";
import UserContext from "../../../contexts/UserContext";
import restService from "../../../restService";

const ChannelsPerformance = ({ state }) => {
  const [user] = useContext(UserContext);
  const [currentChart, setCurrentChart] = useState("Pie");
  const [campaign] = useContext(CampaignContext);
  const [data, setData] = useState([]);

  const [errorMessage, setErrorMessage] = useState(null);

  const channels = [
    { type: "USSD", value: "USSD" },
    { type: "WEB", value: "Web" },
    { type: "MESSENGER", value: "Messenger" },
    { type: "WHATSAPP", value: "WhatsApp" },
  ];

  const [isLoading, setIsLoading] = useState(true);

  const generateColors = (series) => {
    const colors = [];
    series.forEach((_) => {
      colors.push("#" + Math.floor(Math.random() * 16777215).toString(16));
    });
    return colors;
  };

  const globalOptions = {
    colors: generateColors(data),
    chart: {
      type: currentChart === "Bar" ? "column" : "pie",
    },
    title: {
      text: "",
    },
    legend: {
      // align: "top",
      // layout: "vertical",
      align: "left",
      verticalAlign: "top",
      squareSymbol: true,
      symbolHeight: 10,
      symbolWidth: 10,
      symbolRadius: 0,
      itemMarginBottom: 10,
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      formatter: function () {
        return this.point.name + "<br />" + "Total:  " + this.y;
      },
    },
    xAxis: {
      crosshair: true,
      type: "category",
    },
    yAxis: {
      min: 0,
      title: {
        text: "",
      },
    },

    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,
      },
      pie: {
        shadow: false,
        dataLabels: {
          enabled: true,
          format: "{point.name}: {point.percentage:.1f}%",
        },
        showInLegend: true,
      },
    },
    series: [
      {
        colorByPoint: true,
        data,
      },
    ],
  };

  useEffect(() => {
    getChannelPerformance();
  }, [state]);

  const getChannelPerformance = async () => {
    setIsLoading(true);
    try {
      const {
        data: { data },
      } = await restService.reportBreakdown.fetchChannelPerformance(
        campaign?.id,
        new Date(state[0].startDate).toISOString().slice(0, -5),
        new Date(state[0].endDate).toISOString().slice(0, -5)
      );

      const formattedData = channels.map(({ type, value }) => {
        const dataMatch = (data || []).find(
          (item) => item?.channel?.toUpperCase() === type
        );

        const name = value;
        const count = dataMatch ? dataMatch.count : 0;

        return { name, y: count };
      });

      const allYZero = formattedData.every((item) => item.y === 0);

      const finalResult = allYZero ? [] : formattedData;

      setData(finalResult);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);

      console.log(error);
    }
  };

  // const options = [
  //   { value: "chocolate", label: "Chocolate" },
  //   { value: "strawberry", label: "Strawberry" },
  //   { value: "vanilla", label: "Vanilla" },
  // ];

  return (
    <div className="md:px-0 py-5">
      <div className="bg-white shadow w-full flex flex-col gap-2 py-4 md:px-8 px-4">
        <div className="flex items-center justify-between md:flex-row flex-col gap-3">
          <div className="md:min-w-[30%]  min-w-full"></div>
        </div>
        {errorMessage && (
          <p className="text-xs text-[#ff0000]">{errorMessage}</p>
        )}

        <div className="w-full flex items-center justify-center mt-5">
          <h3 className="font-[500] md:text-xl text-lg text-center">
            <span>Channels Performance</span>
          </h3>
        </div>

        {isLoading ? (
          <div className="min-h-[50vh] flex item-center justify-center">
            <PulseLoader color="#FF6A3A" />
          </div>
        ) : (
          <>
            {data?.length < 1 ? (
              <div className="w-full flex justify-center mt-20 mb-20 ">
                <img
                  src={require("../../../assets/images/noData.svg")}
                  alt=""
                />
              </div>
            ) : (
              <div className="mt-11">
                <HighchartsReact
                  highcharts={Highcharts}
                  options={globalOptions}
                  updateArgs={[true, true, true]}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ChannelsPerformance;
